import { useEffect, useRef, useState } from 'react';
import { ensureWsConnection, subscribeWs, subscribeWsConnection, getWsConnected } from '../utils/wsShared';

/**
 * useWebSocket — shared singleton connection
 */
export function useWebSocket(accessToken, handlers = {}) {
  const handlersRef = useRef(handlers);
  const [isConnected, setIsConnected] = useState(getWsConnected());
  const [lastEvent, setLastEvent] = useState(null);

  useEffect(() => {
    handlersRef.current = handlers;
  }, [handlers]);

  useEffect(() => {
    if (!accessToken) return undefined;

    ensureWsConnection(accessToken);

    const wrapped = {
      onNotification: (d) => { setLastEvent({ event: 'notification', data: d }); handlersRef.current.onNotification?.(d); },
      onBookingUpdate: (d) => { setLastEvent({ event: 'booking_update', data: d }); handlersRef.current.onBookingUpdate?.(d); },
      onPaymentUpdate: (d) => { setLastEvent({ event: 'payment_update', data: d }); handlersRef.current.onPaymentUpdate?.(d); },
      onChatMessage: (d) => { setLastEvent({ event: 'chat_message', data: d }); handlersRef.current.onChatMessage?.(d); },
      onChatRead: (d) => { setLastEvent({ event: 'chat_read', data: d }); handlersRef.current.onChatRead?.(d); },
      onChatTyping: (d) => { setLastEvent({ event: 'chat_typing', data: d }); handlersRef.current.onChatTyping?.(d); },
      onChatUpdated: (d) => { setLastEvent({ event: 'chat_updated', data: d }); handlersRef.current.onChatUpdated?.(d); },
      onChatDeleted: (d) => { setLastEvent({ event: 'chat_deleted', data: d }); handlersRef.current.onChatDeleted?.(d); },
      onChatReaction: (d) => { setLastEvent({ event: 'chat_reaction', data: d }); handlersRef.current.onChatReaction?.(d); },
      onMessage: (m) => { setLastEvent(m); handlersRef.current.onMessage?.(m); },
    };

    const unsub = subscribeWs(wrapped);
    const unsubConn = subscribeWsConnection(setIsConnected);

    return () => {
      unsub();
      unsubConn();
    };
  }, [accessToken]);

  return { isConnected, lastEvent };
}

export default useWebSocket;
